export default "__VITE_ASSET__DsSg3fSc__"